import { DoorRef, CustomerRef } from "../../shared/refs";

export interface ServiceContractObject {
  id?: string;
  contractName?: string;
  contractNumber?: string;
  intervalType?: number;
  intervalNumber?: number;
  graceIntervalType?: number;
  reminderInDays?: number;
  startDate?: number;
  endDate?: number;
  phone?: string;
  email?: string;
  notes?: string;
  nextReminder?: number;
  nextService?: number;
  graceDate?: number;
  gateSystemList?: DoorRef[];
  customer?: CustomerRef;
  dateOfService?: number;
}

export class ServiceContract {
  public id?: string;
  contractName?: string;
  contractNumber?: string;
  customer?: CustomerRef;
  intervalType?: number;
  intervalNumber?: number;
  graceIntervalType?: number;
  reminderInDays?: number;
  startDate?: number;
  endDate?: number;
  phone?: string;
  email?: string;
  notes?: string;
  isTenant?: boolean;
  gateSystemList?: DoorRef[];
  nextReminder?: number;
  nextService?: number;
  graceDate?: number;
  dateOfService?: number;

  constructor(serviceContract: ServiceContractObject) {
    Object.assign(this, serviceContract);
    if (serviceContract.nextReminder) {
      this.nextReminder = serviceContract.nextReminder;
    }
    if (serviceContract.nextService) {
      this.nextService = serviceContract.nextService;
    }
    if (serviceContract.graceDate) {
      this.graceDate = serviceContract.graceDate;
    }
  }

  get values(): ServiceContractObject {
    const nonPostProperties = [
      "id",
      "nextReminder",
      "nextService",
      "graceDate",
      "tenant",
      "createdBy",
      "isTenant",
      "timestamp",
      "updatedBy",
      "dateOfService",
    ];
    const values: ServiceContractObject = Object.fromEntries(
      Object.entries(this).filter(
        ([key, value]) => value !== undefined && value !== null && !nonPostProperties.includes(key)
      )
    );
    if (values.gateSystemList) {
      values.gateSystemList = values.gateSystemList.map((door) => {
        return { id: door.id };
      });
    }

    if (values.customer?.label) delete values.customer?.label;
    return values;
  }

  set properties(serviceContract: ServiceContractObject) {
    this.contractName = serviceContract.contractName;
    this.contractNumber = serviceContract.contractNumber;
    this.intervalType = serviceContract.intervalType;
    this.intervalNumber = serviceContract.intervalNumber;
    this.graceIntervalType = serviceContract.graceIntervalType;
    this.reminderInDays = serviceContract.reminderInDays;
    this.startDate = serviceContract.startDate;
    this.endDate = serviceContract.endDate;
    this.phone = serviceContract.phone;
    this.email = serviceContract.email;
    this.notes = serviceContract.notes;
    this.gateSystemList = serviceContract.gateSystemList;
    if (this.customer) {
      this.customer.id = serviceContract.customer?.id;
    } else if (serviceContract.customer?.id) {
      this.customer = { id: serviceContract.customer?.id };
    }
  }
}
